export default __webpack_public_path__ + "static/media/puzzlePiece.2b48f65d.svg";